import Vue from 'vue'
import Vuex from 'vuex'

import Global from './modules/global'
import Administrators from './modules/administrators'
import Accounts from './modules/accounts'
import Areas from './modules/areas'
import Auth from './modules/auth'
import Client from './modules/client'
import ApplicationSettings from './modules/applicationsettings'
import Location from './modules/location'
import Region from './modules/region'
import Map from './modules/map'
import Desk from './modules/desk'
import Tv from './modules/tv'
import Tablet from './modules/tablet'
import Camera from './modules/camera'
import ComfortPack from './modules/comfortpack'
import Space2Check from './modules/space2check'
import Setting from './modules/setting'
import DeskBooking from './modules/deskbooking'
import Feature from './modules/feature'
import User from './modules/user'
import NotificationGroups from './modules/notificationgroups'
import EmployeeGroups from './modules/employeegroups'
import DeskGroups from './modules/deskgroups'
import Locker from './modules/locker'
import Room from './modules/room'
import RestaurantBooking from './modules/restaurantbooking'
import Chartered from './modules/chartered'
import CharteredBooking from './modules/charteredbooking'
import Site from './modules/site'
import Parking from './modules/parking'
import ParkingBooking from './modules/parkingbooking'
import UserBooking from './modules/userbooking'
import LockerBooking from './modules/lockerbooking'
import CostCenter from './modules/costcenter'
import UserSettings from './modules/usersettings'
import Restrictions from './modules/restrictions'
import Contact from './modules/contact'
import Device from './modules/device'
import Report from './modules/report'
import FeatureFlag from './modules/featureflag'
import RoomBooking from './modules/roombooking'
import Document from './modules/document'
import NotificationAlert from './modules/notificationalert'
import Team from './modules/team'
import TeamInvite from './modules/teaminvite'
import SpaceOccupancyDashboard from './modules/spaceoccupancydashboard'
import Event from './modules/event'
import Chat from './modules/chat'
import AccessControl from './modules/accesscontrol'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Global,
    Administrators,
    Accounts,
    Areas,
    Auth,
    Client,
    ApplicationSettings,
    Location,
    Region,
    Map,
    Desk,
    Tv,
    Tablet,
    Device,
    Camera,
    ComfortPack,
    Space2Check,
    Setting,
    DeskBooking,
    Feature,
    User,
    NotificationGroups,
    EmployeeGroups,
    DeskGroups,
    RestaurantBooking,
    Chartered,
    CharteredBooking,
    Site,
    Parking,
    ParkingBooking,
    UserBooking,
    Locker,
    Room,
    LockerBooking,
    CostCenter,
    UserSettings,
    Restrictions,
    Contact,
    Report,
    FeatureFlag,
    RoomBooking,
    Document,
    NotificationAlert,
    Team,
    TeamInvite,
    SpaceOccupancyDashboard,
    Event,
    Chat,
    AccessControl
  }
})
